import React from 'react'
import { MdOutlineArrowRightAlt } from 'react-icons/md'
import AnimatedContent from './Animations/AnimatedContent'
import BlurText from './Animations/BlurText'
import ShinyText from './Animations/ShinyText'

export default function DoraAgaint() {
    return (
        <div className='md:w-[80%] w-[90%] mx-auto md:mt-[5vw] mt-10'>
            <AnimatedContent
                distance={150}
                direction="vertical"
                reverse={false}
                config={{ tension: 80, friction: 20 }}
                initialOpacity={0.2}
                animateOpacity
                scale={1}
                threshold={0.2}
            >
                <div className='DoraAgaint flex items-center flex-col text-center md:gap-3 gap-5 justify-center md:h-[30vw] h-[130vw] rounded-2xl lg:px-20 px-5 py-10'>
                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <BlurText
                            text="What is Agent Dora?"
                            delay={150}
                            animateBy="words"
                            direction="top"
                            className="md:text-4xl text-2xl font-medium md:text-start text-center"
                        />

                    </AnimatedContent>
                    <AnimatedContent
                        distance={150}
                        direction="horizontal"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <p className='md:text-base text-sm font-light' >
                            Agent DORA is the Onchain Agnostic AI Agent of Griffain Engine, fondly called as the Google of Griffain, for its effective On-Chain agnostic search and trading.
                            $AD is the ticker and the AI Meme of Agent DORA, created by the community members of Agent DORA to act as parody and showcase  the true potential and capabilities of Agent DORA to Crypto and global audience, to bring in exponential value proposition and attention to Griffain Platform</p>

                    </AnimatedContent>

                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <button className='md:px-8 px-6 md:py-3 py-2 md:text-base text-sm bg-[#151515] group text-white hover:bg-white transition-all duration-150 hover:text-black flex items-center gap-3 rounded-3xl font-medium '>
                            Buy Now <MdOutlineArrowRightAlt className='group-hover:translate-x-1 transition-all duration-150' />
                        </button>
                    </AnimatedContent>


                </div>
            </AnimatedContent>

        </div>
    )
}
